module.exports = __webpack_public_path__ + "spine/Goaty.json?dc9d03c13ff6096b45ceac22a4e49dd4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spine/goat/Goaty.json
// module id = 1743
// module chunks = 3